import {
  createClassAppIntegrationAsync,
  deleteClassAppIntegrationAsync,
  getAllClassAppIntegrationsAsync,
  getClassAppIntegrationByIdAsync,
  updateClassAppIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';
import { IClassAppprops } from '../../types';

export const useCreateClassAppIntegrationAsync = () =>
  useMutation(createClassAppIntegrationAsync);

export const useGetClassAppIntegrationByIdAsync = () =>
  useMutation(getClassAppIntegrationByIdAsync);

export const useGetAllClassAppIntegrationsAsync = () =>
  useMutation(getAllClassAppIntegrationsAsync);

export const useUpdateClassAppIntegrationAsync = () =>
  useMutation(updateClassAppIntegrationAsync);

export const useDeleteClassAppIntegrationAsync = () =>
  useMutation(deleteClassAppIntegrationAsync);
